import React from "react";
import "../index.css";

function Section({ id, title, content, content_2, bgColor, splash, styleClass, img, content2Class }) {
  if (img) {
    return (
      <section id={id} className={styleClass}>
        <div class="row">
          <div class="col-md-4">
            <div class="image-section">
              <img src={img} alt={title} />
            </div>
          </div>
          <div class="col-md-8">
            <div class="content-section">
              <h2>{title}</h2>
              <p>{content}</p>
              <br/>
              <p><div className={content2Class} dangerouslySetInnerHTML={{ __html: content_2 }} /></p>
            </div>
          </div>
        </div>
        {splash && <div className="splash-overlay" />}
      </section>
    );
  } else {
    return (
      <section id={id} className={styleClass}>
        <div class="row">
          <div class="col-md-12">
            <div className="text">
              <h2>{title}</h2>
              <p>{content}</p>
              <br/>
              <p><div dangerouslySetInnerHTML={{ __html: content_2 }} /></p>
            </div>
          </div>
        </div>
        {splash && <div className="splash-overlay" />}
      </section>
    );
  }
}

export default Section;
